import { APIV2_URL } from './constants';
import { MakeCall } from './createMakeCall';

export interface SurveyData {
  isHa?: boolean;
  isRented?: boolean;
  isLocalStudent?: boolean;
  reason?: string;
  how?: string;
  why?: string;
}

export default (makeCall: MakeCall) => (listingId: number, data: SurveyData) => {
  return makeCall<undefined>(
    'POST',
    `${APIV2_URL}/listing/${listingId}/survey`,
    { data },
  );
};
